import { IconPropsType } from '..';

export const PlayersIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 13.1154C12.1029 13.1154 13.8077 11.4106 13.8077 9.30769C13.8077 7.20476 12.1029 5.5 10 5.5C7.89707 5.5 6.19231 7.20476 6.19231 9.30769C6.19231 11.4106 7.89707 13.1154 10 13.1154Z"
      fill="currentColor"
    />
    <path
      d="M10 1C8.21997 1 6.47991 1.52784 4.99987 2.51677C3.51983 3.50571 2.36628 4.91131 1.68509 6.55585C1.0039 8.20038 0.82567 10.01 1.17294 11.7558C1.5202 13.5016 2.37737 15.1053 3.63604 16.364C4.89471 17.6226 6.49836 18.4798 8.24419 18.8271C9.99002 19.1743 11.7996 18.9961 13.4442 18.3149C15.0887 17.6337 16.4943 16.4802 17.4832 15.0001C18.4722 13.5201 19 11.78 19 10C18.9954 7.61446 18.0457 5.32793 16.3589 3.64109C14.6721 1.95425 12.3855 1.00457 10 1ZM15.6942 15.0538C15.1338 14.25 14.4117 13.572 13.574 13.0635C12.6123 13.9848 11.3319 14.4992 10 14.4992C8.66813 14.4992 7.38771 13.9848 6.42596 13.0635C5.58833 13.572 4.86618 14.25 4.30577 15.0538C3.33116 13.9563 2.69447 12.6006 2.47233 11.1497C2.2502 9.69882 2.45208 8.21466 3.05369 6.87583C3.6553 5.53701 4.63099 4.40056 5.86335 3.60327C7.09571 2.80597 8.53222 2.3818 10 2.3818C11.4678 2.3818 12.9043 2.80597 14.1367 3.60327C15.369 4.40056 16.3447 5.53701 16.9463 6.87583C17.5479 8.21466 17.7498 9.69882 17.5277 11.1497C17.3055 12.6006 16.6688 13.9563 15.6942 15.0538Z"
      fill="currentColor"
    />
  </svg>
);
